"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileCSVSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FileCSVSVG = function FileCSVSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28,13H27V9.84a2.0156,2.0156,0,0,0-.58-1.41L20.59,2.59A1.966,1.966,0,0,0,19.18,2H7A2.0059,2.0059,0,0,0,5,4v9H4a2.0059,2.0059,0,0,0-2,2v9a2.0059,2.0059,0,0,0,2,2H5v2a2.0059,2.0059,0,0,0,2,2H25a2.0059,2.0059,0,0,0,2-2V26h1a2.0059,2.0059,0,0,0,2-2V15A2.0059,2.0059,0,0,0,28,13ZM7,4H18V9a2.0059,2.0059,0,0,0,2,2h5v2H7ZM24.38,16.87,22.46,22.2H20.94l-1.93-5.33h1.44l1.26,4.08h.05L23,16.87Zm-8.46,3.19-.88-.18c-.83-.17-1.52-.59-1.52-1.49,0-1.05.98-1.63,2.23-1.63,1.31,0,2.19.65,2.2,1.6H16.79c-.03-.38-.37-.73-1.05-.73-.6,0-.97.26-.97.67,0,.31.27.52.8.61l.89.18c.86.17,1.58.55,1.58,1.52,0,1.05-.89,1.69-2.35,1.69-1.73,0-2.29-.88-2.31-1.63h1.2c.04.39.43.74,1.17.74.69,0,1.06-.28,1.06-.69C16.81,20.36,16.51,20.18,15.92,20.06ZM9.86,21.35a1.0123,1.0123,0,0,0,1.13-1.01h1.19v.12c0,.97-.85,1.84-2.34,1.84a2.2573,2.2573,0,0,1-2.48-2.46v-.6a2.2722,2.2722,0,0,1,2.49-2.47c1.45,0,2.33.85,2.33,1.89v.11H10.99a1.0539,1.0539,0,0,0-1.13-1.06c-.75,0-1.24.51-1.24,1.53v.6C8.62,20.87,9.11,21.35,9.86,21.35ZM25,28H7V26H25Z"
  }));
};
exports.FileCSVSVG = FileCSVSVG;
FileCSVSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileCSVSVG);
exports.default = _default;